export const T = {
  en_GB: {
    assetClass: "Asset Class",
    noData: "No asset class forecast data available for this selection.",
  },
  nb_NO: {
    assetClass: "Aktivaklasse",
    noData: "Ingen aktivaklasseprognose er tilgjengelig for dette utvalget.",
  },
} as const;
